import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';

import { MarkTypes, StoryblokRichTextNode } from '@storyblok/richtext';
import { DynamicModule } from 'ng-dynamic-component';
import { MarkdownModule } from 'ngx-markdown';

import { SheetModule } from '@valk-nx/components/ui-sheet/src/lib/sheet.module';
import { TileComponent } from '@valk-nx/components/ui-tile/src/lib/tile';
import { HeadingDirective } from '@valk-nx/core/lib/directives/heading/heading.directive';
import { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';
import { prependInternalLinkResolver } from '@valk-nx/storyblok/components/richtext/src/lib/custom-resolvers';
import { RichTextComponent } from '@valk-nx/storyblok/components/richtext/src/lib/rich-text';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';

export interface Tile {
	title: string;
	icon: string;
	description: string | StoryblokRichTextNode;
}
@Component({
	selector: 'sb-tile-group-section',
	templateUrl: './tile-group-section.html',
	imports: [
		CommonModule,
		DynamicModule,
		HeadingDirective,
		MarkdownModule,
		SheetModule,
		RichTextComponent,
		StoryblokDirective,
		TileComponent,
	],
})
export class TileGroupSectionComponent extends StoryblokRootDirective {
	tiles = input.required<Tile[]>();
	title = input.required<string>();

	headingType = input<HeadingType>('h2');

	prependInternalLinksWith = input<string>('');

	selectedTile = signal<Tile | undefined>(undefined);

	richTextResolvers = computed(() => {
		if (this.prependInternalLinksWith() != '') {
			return {
				[MarkTypes.LINK]: prependInternalLinkResolver(
					this.prependInternalLinksWith(),
				),
			};
		}
		return {};
	});

	constructor() {
		super();
	}

	onTileClick(tile: Tile) {
		this.selectedTile.set(tile);
	}

	onSheetClose() {
		this.selectedTile.set(undefined);
	}
}
